module.exports = __webpack_public_path__ + "img/IT0000207618881.0c1be5c1.png";